import { $ } from "@/common/Axios";

export default {
  /**
   * 转账
   */
  transfer_syncPayStatus: {
    /*
     * 同步打款状态
     * payAccount 打款账号 (string query required)
     * outBizNo 订单号 (string query required)
     */
    put: (p, c) => $.put("/api/fms/finance/transfer/syncPayStatus", p, c),
  },
  transfer_listByContentId: {
    /*
     * 打款记录
     * contentId 打款账号 (integer query required)
     */
    get: (p, c) => $.get("/api/fms/finance/transfer/listByContentId", p, c),
  },
  transfer: {
    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/fms/finance/transfer", p, c),
  },

  /**
   * 学生缴费单
   */
  studentFees: {
    /*
     * 编辑
     * id 缴费单id (integer query required)
     * accountingTime 入账时间 (string query )
     * discountWay 优惠方式 (string query )
     * discountAmount 优惠金额 (number query required)
     * standard 标准 (number query required)
     */
    put: (p, c) => $.put("/api/fms/finance/studentFees", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/fms/finance/studentFees", p, c),
  },
  studentFees_updateAccountingTime: {
    /*
     * 修改入账时间
     * ids 缴费单id (array query required)
     * accountingTime 入账时间，不填为清空 (string query )
     */
    put: (p, c) =>
      $.put("/api/fms/finance/studentFees/updateAccountingTime", p, c),
  },
  studentFees_upload: {
    /*
     * 导入
     * excelFile  (string body required)
     */
    post: (p, c) => $.post("/api/fms/finance/studentFees/upload", p, c),
  },
  studentFees_uploadForSite: {
    /*
     * 导入
     * excelFile  (string body required)
     */
    post: (p, c) => $.post("/api/fms/finance/studentFees/uploadForSite", p, c),
  },
  studentFees_setContinueCertConfig: {
    /*
     * 设置职教证书配置
     * configText 证书配置 (string query required)
     */
    post: (p, c) =>
      $.post("/api/fms/finance/studentFees/setContinueCertConfig", p, c),
  },
  studentFees_createForContinueCert: {
    /*
     * 生成证书收费单
     * schoolRollId 合同id (integer query required)
     * courseTypes 课程类型 (array query required)
     * courseNames 课程名称 (array query required)
     */
    post: (p, c) =>
      $.post("/api/fms/finance/studentFees/createForContinueCert", p, c),
  },
  studentFees_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/fms/finance/studentFees/list", p, c),
  },
  studentFees_listSimple: {
    /*
     * 简易列表
     * schoolRollId 合同id (integer query )
     */
    get: (p, c) => $.get("/api/fms/finance/studentFees/listSimple", p, c),
  },
  studentFees_listForSite: {
    /*
     * 列表（校区）
     */
    get: (p, c) => $.get("/api/fms/finance/studentFees/listForSite", p, c),
  },
  studentFees_listForIndividualStudentFees: {
    /*
     * 个体工商户增值收费单列表
     */
    get: (p, c) =>
      $.get("/api/fms/finance/studentFees/listForIndividualStudentFees", p, c),
  },
  studentFees_getStudentClientFee: {
    /*
     * 获取学生缴费单C端信息
     * batch 批次 (string query )
     * siteId 学校id (string query )
     * type 缴费类型 (string query )
     * idCardNo 身份证 (string query )
     */
    get: (p, c) =>
      $.get("/api/fms/finance/studentFees/getStudentClientFee", p, c),
  },
  studentFees_getContinueCertInfo: {
    /*
     * 获取职教证书信息
     * schoolRollId 合同id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/fms/finance/studentFees/getContinueCertInfo", p, c),
  },
  studentFees_getContinueCertConfig: {
    /*
     * 获取职教证书配置
     */
    get: (p, c) =>
      $.get("/api/fms/finance/studentFees/getContinueCertConfig", p, c),
  },
  studentFees_export: {
    /*
     * 批量导出
     */
    get: (p, c) => $.get("/api/fms/finance/studentFees/export", p, c),
  },
  studentFees_exportForSite: {
    /*
     * 批量导出（校区）
     */
    get: (p, c) => $.get("/api/fms/finance/studentFees/exportForSite", p, c),
  },
  studentFees_exportForIndividualStudentFees: {
    /*
     * 个体工商户增值收费单列表导出
     */
    get: (p, c) =>
      $.get(
        "/api/fms/finance/studentFees/exportForIndividualStudentFees",
        p,
        c
      ),
  },

  /**
   * 发票
   */
  receipt_receipt: {
    /*
     * 开票
     * id 发票id (integer query required)
     * receipt 发票地址 (string query required)
     * discuss 评论 (string query required)
     */
    put: (p, c) => $.put("/api/fms/finance/receipt/receipt", p, c),
  },
  receipt_reapply: {
    /*
     * 重新申请开票
     * id 发票id (integer query required)
     * invoiceType 发票类型：普票，专票 (string query required)
     * title 抬头 (string query required)
     * taxNumber 税号 (string query required)
     * openBank 开户行, 如果发票类型为专票的话必填 (string query )
     * discuss 评论 (string query required)
     */
    put: (p, c) => $.put("/api/fms/finance/receipt/reapply", p, c),
  },
  receipt_apply: {
    /*
     * 申请开票
     * type 类型：学费业务，增值业务 (string query required)
     * invoiceType 发票类型：普票，专票 (string query required)
     * contentId 内容id (integer query required)
     * amount 金额 (number query required)
     * title 抬头 (string query required)
     * taxNumber 税号 (string query required)
     * openBank 开户行, 如果发票类型为专票的话必填 (string query )
     */
    post: (p, c) => $.post("/api/fms/finance/receipt/apply", p, c),
  },
  receipt_listForStudentFees: {
    /*
     * 增值业务发票列表
     */
    get: (p, c) => $.get("/api/fms/finance/receipt/listForStudentFees", p, c),
  },
  receipt_listForFeeNote: {
    /*
     * 学费业务发票列表
     */
    get: (p, c) => $.get("/api/fms/finance/receipt/listForFeeNote", p, c),
  },
  receipt_listByContentId: {
    /*
     * 根据内容id获取发票列表
     * contentId 内容id，对应收费单id或学生缴费单id (integer query required)
     * type 类型：学费业务、增值业务 (string query required)
     */
    get: (p, c) => $.get("/api/fms/finance/receipt/listByContentId", p, c),
  },
  receipt_detailsForStudentFees: {
    /*
     * 增值业务发票详情
     * id 发票id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/fms/finance/receipt/detailsForStudentFees", p, c),
  },
  receipt_detailsForFeeNote: {
    /*
     * 学历业务发票详情
     * id 发票id (integer query required)
     */
    get: (p, c) => $.get("/api/fms/finance/receipt/detailsForFeeNote", p, c),
  },
  receipt: {
    /*
     * 删除
     * id 发票id (integer query required)
     */
    delete: (p, c) => $.delete("/api/fms/finance/receipt", p, c),
  },

  /**
   * 付款单
   */
  payment_remark: {
    /*
     * 打款备注
     * id id (integer query required)
     * remark 备注 (string query )
     */
    put: (p, c) => $.put("/api/fms/finance/payment/remark", p, c),
  },
  payment_reapply: {
    /*
     * 重新申请付款单
     * id id (integer query required)
     * attachment 附件 (string query )
     * amount 金额 (number query )
     * accountType 账号类型：支付宝 (string query )
     * accountNick 账号昵称 (string query )
     * account 账号 (string query )
     * remark 备注 (string query )
     */
    put: (p, c) => $.put("/api/fms/finance/payment/reapply", p, c),
  },
  payment_uploadNightRebate: {
    /*
     * 导入夜校返款单
     * file  (string body required)
     */
    post: (p, c) => $.post("/api/fms/finance/payment/uploadNightRebate", p, c),
  },
  payment_pay: {
    /*
     * 打款
     * id id (integer query required)
     * flowId 流程 (integer query required)
     * payAccount 打款账号 (string query required)
     * remark 备注 (string query )
     * needSceneInfo 是否需要转账场景信息（新商户必传；true=带，false=不带，不传默认带） (boolean query )
     */
    post: (p, c) => $.post("/api/fms/finance/payment/pay", p, c),
  },
  payment_apply: {
    /*
     * 申请付款单
     * type 类型：毕业照片退费、增值流失退费、优惠付款单、档案管理退费 (string query required)
     * schoolRollId 合同id (integer query required)
     * contentId 内容id (integer query required)
     * attachment 附件 (string query )
     * amount 金额 (number query )
     * accountType 账号类型：支付宝 (string query )
     * accountNick 账号昵称 (string query )
     * account 账号 (string query )
     * remark 备注 (string query )
     */
    post: (p, c) => $.post("/api/fms/finance/payment/apply", p, c),
  },
  payment_listSimple: {
    /*
     * 简易列表
     * schoolRollId 合同id (integer query )
     * contentId 内容id (integer query )
     * type 类型 (string query required)
     */
    get: (p, c) => $.get("/api/fms/finance/payment/listSimple", p, c),
  },
  payment_listRefundValueAddedLossForApproval: {
    /*
     * 增值流失退费审批列表
     */
    get: (p, c) =>
      $.get(
        "/api/fms/finance/payment/listRefundValueAddedLossForApproval",
        p,
        c
      ),
  },
  payment_listRefundPhotoForApproval: {
    /*
     * 毕业照片退费审批列表
     */
    get: (p, c) =>
      $.get("/api/fms/finance/payment/listRefundPhotoForApproval", p, c),
  },
  payment_listRefundPhotoForApply: {
    /*
     * 毕业照片退费申请列表
     */
    get: (p, c) =>
      $.get("/api/fms/finance/payment/listRefundPhotoForApply", p, c),
  },
  payment_listRefundDocManager: {
    /*
     * 档案管理费列表
     */
    get: (p, c) => $.get("/api/fms/finance/payment/listRefundDocManager", p, c),
  },
  payment_listNightRebate: {
    /*
     * 夜校返款单列表
     */
    get: (p, c) => $.get("/api/fms/finance/payment/listNightRebate", p, c),
  },
  payment_listNightPayment: {
    /*
     * 夜校退费单列表
     */
    get: (p, c) => $.get("/api/fms/finance/payment/listNightPayment", p, c),
  },
  payment_listDiscountForApproval: {
    /*
     * 优惠付款单列表
     */
    get: (p, c) =>
      $.get("/api/fms/finance/payment/listDiscountForApproval", p, c),
  },
  payment_exportRefundValueAddedLossForApproval: {
    /*
     * 增值流失退费审批列表导出
     */
    get: (p, c) =>
      $.get(
        "/api/fms/finance/payment/exportRefundValueAddedLossForApproval",
        p,
        c
      ),
  },
  payment_exportRefundPhotoForApproval: {
    /*
     * 毕业照片退费审批列表导出
     */
    get: (p, c) =>
      $.get("/api/fms/finance/payment/exportRefundPhotoForApproval", p, c),
  },
  payment_exportNightRebate: {
    /*
     * 导出夜校返款单
     */
    get: (p, c) => $.get("/api/fms/finance/payment/exportNightRebate", p, c),
  },
  payment_exportNightPayment: {
    /*
     * 导出夜校退费单
     */
    get: (p, c) => $.get("/api/fms/finance/payment/exportNightPayment", p, c),
  },
  payment_exportDiscountForApproval: {
    /*
     * 导出优惠付款单
     */
    get: (p, c) =>
      $.get("/api/fms/finance/payment/exportDiscountForApproval", p, c),
  },
  payment_details: {
    /*
     * 付款单详情
     * id id (integer query required)
     */
    get: (p, c) => $.get("/api/fms/finance/payment/details", p, c),
  },
  payment_detailsForRefundPhoto: {
    /*
     * 照片采集退费付款单详情
     * id id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/fms/finance/payment/detailsForRefundPhoto", p, c),
  },
  payment_detailsForNight: {
    /*
     * 夜校退费单
     * id id (integer query required)
     */
    get: (p, c) => $.get("/api/fms/finance/payment/detailsForNight", p, c),
  },
  payment_detailsForNightRebate: {
    /*
     * 夜校返款单详情
     * id id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/fms/finance/payment/detailsForNightRebate", p, c),
  },
  payment_detailsByApprovalId: {
    /*
     * 付款单详情
     * id id (integer query required)
     */
    get: (p, c) => $.get("/api/fms/finance/payment/detailsByApprovalId", p, c),
  },

  /**
   * 订单
   */
  order: {
    /*
     * 编辑
     * id 订单id (integer query required)
     * type 类型:收费订单,退费订单 (string query required)
     * orderNo 订单号 (string query required)
     * sort 订单拆分排序： -1, -2 (string query )
     * payAccount 收款账号 (string query required)
     * amount 金额 (number query required)
     * applyRemark 申请备注 (string query )
     * attachment 附件 (string query required)
     * payTime 支付时间 (string query )
     * accountType 退费账号类型，退费有 (string query )
     * accountNick 退费账号名字，退费有 (string query )
     * account 退费账号，退费有 (string query )
     */
    put: (p, c) => $.put("/api/fms/finance/order", p, c),

    /*
     * 添加
     * type 类型:收费订单,退费订单 (string query required)
     * orderType 订单类型 (string query required)
     * userId 用户id (integer query required)
     * orderNo 订单号 (string query )
     * sort 订单拆分排序： -1, -2 (string query )
     * payAccount 收款账号 (string query )
     * contentId 内容id (integer query required)
     * amount 金额 (number query required)
     * applyRemark 申请备注 (string query )
     * attachment 附件，退费订单的时候也显示，但是选填 (string query )
     * payTime 支付时间 (string query )
     * accountType 退费账号类型，退费有 (string query )
     * accountNick 退费账号名字，退费有 (string query )
     * account 退费账号，退费有 (string query )
     */
    post: (p, c) => $.post("/api/fms/finance/order", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/fms/finance/order", p, c),
  },
  order_updateAttachment: {
    /*
     * 修改附件
     * orderNo 订单号 (string query required)
     * attachment 附件 (string query required)
     */
    put: (p, c) => $.put("/api/fms/finance/order/updateAttachment", p, c),
  },
  order_updateAccountingTime: {
    /*
     * 修改入账时间
     * id 订单id (integer query required)
     * accountingTime 入账时间，不填为清空 (string query )
     */
    put: (p, c) => $.put("/api/fms/finance/order/updateAccountingTime", p, c),
  },
  order_checkPayResult: {
    /*
     * 查询同步支付结果
     * orderNo 订单号 (string query required)
     */
    put: (p, c) => $.put("/api/fms/finance/order/checkPayResult", p, c),
  },
  order_changeFee: {
    /*
     * 转收费单
     * id 订单id (integer query required)
     * type 收费单类型 (string query required)
     * amount 金额，不填则转收费单多交金额和订单金额的最小值 (number query )
     */
    put: (p, c) => $.put("/api/fms/finance/order/changeFee", p, c),
  },
  order_batchDeny: {
    /*
     * 批量拒绝
     * ids 订单id (array query required)
     */
    put: (p, c) => $.put("/api/fms/finance/order/batchDeny", p, c),
  },
  order_audit: {
    /*
     * 审核
     * orderNo 订单号 (string query required)
     * auditStatus 审核状态：通过，拒绝 (string query required)
     * reason 理由 (string query )
     * confirmed 是否已确认 (boolean query )
     */
    put: (p, c) => $.put("/api/fms/finance/order/audit", p, c),
  },
  order_upload: {
    /*
     * 导入
     * excelFile  (string body required)
     */
    post: (p, c) => $.post("/api/fms/finance/order/upload", p, c),
  },
  order_uploadPhotoOrder: {
    /*
     * 导入
     * excelFile  (string body required)
     */
    post: (p, c) => $.post("/api/fms/finance/order/uploadPhotoOrder", p, c),
  },
  order_uploadForStudentFee: {
    /*
     * 缴费单订单导入
     * excelFile  (string body required)
     */
    post: (p, c) => $.post("/api/fms/finance/order/uploadForStudentFee", p, c),
  },
  order_restore: {
    /*
     * 批量修复
     * excelFile  (string body required)
     */
    post: (p, c) => $.post("/api/fms/finance/order/restore", p, c),
  },
  order_payFee: {
    /*
     * 获取支付信息（orderNo 订单号, payUrl 支付地址）
     * userId 用户id：以前段传过来为主，不传则取当前登陆用户id (integer query )
     * orderType 订单类型：学历学费，毕业拍照，专升本，成考宝典VIP(SVIP)，成考宝典课程 (string query required)
     * feeId 收费单id (integer query required)
     * amount 金额 (number query required)
     * payAccount 收款账号 (string query required)
     * type 类型：APP，H5, MP, ACCOUNT (string query required)
     * body 产品详情 (string query )
     * remark 备注 (string query )
     * returnUrl 返回地址 (string query )
     * period 花呗分期，暂时忽略 (integer query )
     * payerId 汇付斗拱付款人信息 (string query )
     */
    post: (p, c) => $.post("/api/fms/finance/order/payFee", p, c),
  },
  order_payFeeForStudentFees: {
    /*
     * 获取学生缴费单支付信息（orderNo 订单号, payUrl 支付地址）
     * userId 用户id：以前段传过来为主，不传则取当前登陆用户id (integer query )
     * orderType 订单类型：学历学费，毕业拍照，专升本，成考宝典VIP(SVIP)，成考宝典课程，学生缴费单 (string query required)
     * feeIds 收费单id列表 (array query required)
     * amounts 金额 (array query required)
     * payAccount 收款账号 (string query required)
     * type 类型：APP，H5, MP, ACCOUNT (string query required)
     * returnUrl 返回地址 (string query )
     * period 花呗分期，暂时忽略 (integer query )
     * payerId 付款人id（汇付） (string query )
     */
    post: (p, c) => $.post("/api/fms/finance/order/payFeeForStudentFees", p, c),
  },
  order_deletePaid: {
    /*
     * 删除已通过的订单（删除后回退缴费状态）
     * id 订单id (integer query required)
     */
    post: (p, c) => $.post("/api/fms/finance/order/deletePaid", p, c),
  },
  order_sumByContentId: {
    /*
     * 根据内容id获取金额
     * contentId 内容id (integer query required)
     * orderType 订单类型：学费订单、转批次 (string query required)
     */
    get: (p, c) => $.get("/api/fms/finance/order/sumByContentId", p, c),
  },
  order_renderReceipt: {
    /*
     * 渲染收据信息
     * id id (integer query required)
     * remark 备注 (string query )
     */
    get: (p, c) => $.get("/api/fms/finance/order/renderReceipt", p, c),
  },
  order_listTuitionOrder: {
    /*
     * 学费订单列表
     */
    get: (p, c) => $.get("/api/fms/finance/order/listTuitionOrder", p, c),
  },
  order_listStudentFeesOrder: {
    /*
     * 学生缴费单订单列表
     */
    get: (p, c) => $.get("/api/fms/finance/order/listStudentFeesOrder", p, c),
  },
  order_listSiteOrderForContinue: {
    /*
     * 继教院学校订单列表
     */
    get: (p, c) =>
      $.get("/api/fms/finance/order/listSiteOrderForContinue", p, c),
  },
  order_listSimpleByContentId: {
    /*
     * 根据内容id获取简易订单列表
     * contentId 内容id (integer query required)
     * orderType 订单类型：学费订单、转批次 (string query )
     */
    get: (p, c) => $.get("/api/fms/finance/order/listSimpleByContentId", p, c),
  },
  order_listPhotoOrder: {
    /*
     * 毕业拍照订单列表
     */
    get: (p, c) => $.get("/api/fms/finance/order/listPhotoOrder", p, c),
  },
  order_listNightOrder: {
    /*
     * 夜校订单列表
     */
    get: (p, c) => $.get("/api/fms/finance/order/listNightOrder", p, c),
  },
  order_listForSelfManagerFee: {
    /*
     * 自考代管费列表
     */
    get: (p, c) => $.get("/api/fms/finance/order/listForSelfManagerFee", p, c),
  },
  order_listForSelfManagerFeeByService: {
    /*
     * 自考代管费列表（服务模块）
     */
    get: (p, c) =>
      $.get("/api/fms/finance/order/listForSelfManagerFeeByService", p, c),
  },
  order_listForSelfManagerFeeByContentId: {
    /*
     * 自考代管费简易列表
     * contentId 内容id（合同编号） (integer query required)
     */
    get: (p, c) =>
      $.get("/api/fms/finance/order/listForSelfManagerFeeByContentId", p, c),
  },
  order_listForIndividualStudentFeesOrder: {
    /*
     * 个体工商户增值订单列表
     */
    get: (p, c) =>
      $.get("/api/fms/finance/order/listForIndividualStudentFeesOrder", p, c),
  },
  order_listDocManager: {
    /*
     * 档案管理费订单列表
     */
    get: (p, c) => $.get("/api/fms/finance/order/listDocManager", p, c),
  },
  order_listChangeBatch: {
    /*
     * 转批次订单列表
     */
    get: (p, c) => $.get("/api/fms/finance/order/listChangeBatch", p, c),
  },
  order_exportTuitionOrder: {
    /*
     * 学费订单列表导出
     */
    get: (p, c) => $.get("/api/fms/finance/order/exportTuitionOrder", p, c),
  },
  order_exportTuitionOrderForBigData: {
    /*
     * 学费订单列表大量导出
     */
    get: (p, c) =>
      $.get("/api/fms/finance/order/exportTuitionOrderForBigData", p, c),
  },
  order_exportStudentFeesOrder: {
    /*
     * 学生缴费单订单列表导出
     */
    get: (p, c) => $.get("/api/fms/finance/order/exportStudentFeesOrder", p, c),
  },
  order_exportSiteOrderForContinue: {
    /*
     * 导出继教院学校订单列表
     */
    get: (p, c) =>
      $.get("/api/fms/finance/order/exportSiteOrderForContinue", p, c),
  },
  order_exportPhotoOrder: {
    /*
     * 毕业拍照订单列表导出
     */
    get: (p, c) => $.get("/api/fms/finance/order/exportPhotoOrder", p, c),
  },
  order_exportNightOrder: {
    /*
     * 夜校订单列表导出
     */
    get: (p, c) => $.get("/api/fms/finance/order/exportNightOrder", p, c),
  },
  order_exportForSelfManagerFee: {
    /*
     * 自考代管费导出
     */
    get: (p, c) =>
      $.get("/api/fms/finance/order/exportForSelfManagerFee", p, c),
  },
  order_exportForSelfManagerFeeByService: {
    /*
     * 自考代管费导出
     */
    get: (p, c) =>
      $.get("/api/fms/finance/order/exportForSelfManagerFeeByService", p, c),
  },
  order_exportForIndividualStudentFeesOrder: {
    /*
     * 个体工商户增值订单列表导出
     */
    get: (p, c) =>
      $.get("/api/fms/finance/order/exportForIndividualStudentFeesOrder", p, c),
  },
  order_exportDocManager: {
    /*
     * 档案管理费订单列表导出
     */
    get: (p, c) => $.get("/api/fms/finance/order/exportDocManager", p, c),
  },
  order_downloadRestoreModule: {
    /*
     * 下载修复模版
     */
    get: (p, c) => $.get("/api/fms/finance/order/downloadRestoreModule", p, c),
  },
  order_downloadPhotoOrderModule: {
    /*
     * 下载照片采集订单导入模版
     */
    get: (p, c) =>
      $.get("/api/fms/finance/order/downloadPhotoOrderModule", p, c),
  },
  order_downloadModule: {
    /*
     * 下载导入模版
     */
    get: (p, c) => $.get("/api/fms/finance/order/downloadModule", p, c),
  },
  order_downloadModuleForStudentFee: {
    /*
     * 下载缴费单订单导入模版
     */
    get: (p, c) =>
      $.get("/api/fms/finance/order/downloadModuleForStudentFee", p, c),
  },

  /**
   * 收支明细
   */
  incomeExpense: {
    /*
     * 编辑
     * id id (integer query required)
     * type 类别 (string query required)
     * subType 子类别 (string query required)
     * summary 摘要 (string query required)
     * department 部门 (string query required)
     * cashItem 现金流量表项目 (string query required)
     */
    put: (p, c) => $.put("/api/fms/finance/incomeExpense", p, c),

    /*
     * 删除
     * ids ids (array query required)
     */
    delete: (p, c) => $.delete("/api/fms/finance/incomeExpense", p, c),
  },
  incomeExpense_upload: {
    /*
     * 批量导入
     * excelFile  (string body required)
     */
    post: (p, c) => $.post("/api/fms/finance/incomeExpense/upload", p, c),
  },
  incomeExpense_list: {
    /*
     * 收支明细列表
     */
    get: (p, c) => $.get("/api/fms/finance/incomeExpense/list", p, c),
  },
  incomeExpense_listFlat: {
    /*
     * 需要收支平衡的资金情况列表
     */
    get: (p, c) => $.get("/api/fms/finance/incomeExpense/listFlat", p, c),
  },
  incomeExpense_listDepartment: {
    /*
     * 部门列表
     */
    get: (p, c) => $.get("/api/fms/finance/incomeExpense/listDepartment", p, c),
  },
  incomeExpense_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/fms/finance/incomeExpense/export", p, c),
  },

  /**
   * 收费单
   */
  feeNote_updateAccountingTime: {
    /*
     * 修改入账时间
     * id 订单id (integer query required)
     * accountingTime 入账时间，不填为清空 (string query )
     */
    put: (p, c) => $.put("/api/fms/finance/feeNote/updateAccountingTime", p, c),
  },
  feeNote_restore: {
    /*
     * 导入
     * excelFile  (string body required)
     */
    post: (p, c) => $.post("/api/fms/finance/feeNote/restore", p, c),
  },
  feeNote_createFee: {
    /*
     * 管理端生成收费单
     * schoolRollId 学籍id (integer query required)
     */
    post: (p, c) => $.post("/api/fms/finance/feeNote/createFee", p, c),
  },
  feeNote_createFeeForClient: {
    /*
     * C端生成收费单
     * schoolRollId 学籍id (integer query required)
     */
    post: (p, c) => $.post("/api/fms/finance/feeNote/createFeeForClient", p, c),
  },
  feeNote_viewFollow: {
    /*
     * 催费视图
     * siteType 学校类型 (string query )
     * batch 批次 (string query )
     * rollGrade 学籍年级 (string query )
     * province 省份 (string query )
     * sameIndustry 是否同行：是，否 (string query )
     * feeTypes 收费单类型 (array query )
     * schoolStatuses 学籍状态 (array query )
     * start 缴费时间开始 (string query )
     * end 缴费时间结束 (string query )
     */
    get: (p, c) => $.get("/api/fms/finance/feeNote/viewFollow", p, c),
  },
  feeNote_listTuitionFee: {
    /*
     * 学费收费单列表
     */
    get: (p, c) => $.get("/api/fms/finance/feeNote/listTuitionFee", p, c),
  },
  feeNote_listSpecificFollowFeeInfo: {
    /*
     * 催费具体视图
     * siteType 学校类型 (string query required)
     * rollGrade 学籍年级 (string query required)
     * feeType 费用类型 (string query required)
     * type 类型：同行，非同行 (string query required)
     */
    get: (p, c) =>
      $.get("/api/fms/finance/feeNote/listSpecificFollowFeeInfo", p, c),
  },
  feeNote_listPromoteXmtTuitionFee: {
    /*
     * 新媒体学费收费单列表
     */
    get: (p, c) =>
      $.get("/api/fms/finance/feeNote/listPromoteXmtTuitionFee", p, c),
  },
  feeNote_listPromoteNetTuitionFee: {
    /*
     * 网络推广学费收费单列表
     */
    get: (p, c) =>
      $.get("/api/fms/finance/feeNote/listPromoteNetTuitionFee", p, c),
  },
  feeNote_listForStudentDetails: {
    /*
     * 学生详情收费单列表
     * schoolRollId 学籍id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/fms/finance/feeNote/listForStudentDetails", p, c),
  },
  feeNote_listFollowTuitionFee: {
    /*
     * 催费列表
     */
    get: (p, c) => $.get("/api/fms/finance/feeNote/listFollowTuitionFee", p, c),
  },
  feeNote_listFollowTuitionFeeForService: {
    /*
     * 服务部催费列表
     */
    get: (p, c) =>
      $.get("/api/fms/finance/feeNote/listFollowTuitionFeeForService", p, c),
  },
  feeNote_listFollowTuitionFeeForContinue: {
    /*
     * 继教院催费列表
     */
    get: (p, c) =>
      $.get("/api/fms/finance/feeNote/listFollowTuitionFeeForContinue", p, c),
  },
  feeNote_listAiMarketingTuitionFee: {
    /*
     * AI营销收费单列表
     */
    get: (p, c) =>
      $.get("/api/fms/finance/feeNote/listAiMarketingTuitionFee", p, c),
  },
  feeNote_getTuitionClientFee: {
    /*
     * 获取学费收费单C端信息
     * batch 批次 (string query )
     * siteId 学校id (string query )
     * type 缴费类型 (string query )
     * idCardNo 身份证 (string query )
     */
    get: (p, c) => $.get("/api/fms/finance/feeNote/getTuitionClientFee", p, c),
  },
  feeNote_getClientFee: {
    /*
     * 获取C端缴费信息
     * schoolRollId 学籍id (integer query )
     * userId 用户id (integer query )
     * idCardNo 身份证 (string query )
     * batch 批次 (string query )
     * type 缴费类型 (string query )
     * siteType 学校类型 (string query )
     * feeId 收费单id (integer query )
     */
    get: (p, c) => $.get("/api/fms/finance/feeNote/getClientFee", p, c),
  },
  feeNote_exportTuitionFee: {
    /*
     * 学费收费单导出
     */
    get: (p, c) => $.get("/api/fms/finance/feeNote/exportTuitionFee", p, c),
  },
  feeNote_exportTuitionFeeForBigData: {
    /*
     * 学费收费单大量导出
     */
    get: (p, c) =>
      $.get("/api/fms/finance/feeNote/exportTuitionFeeForBigData", p, c),
  },
  feeNote_exportPromoteXmtTuitionFee: {
    /*
     * 新媒体学费收费单导出
     */
    get: (p, c) =>
      $.get("/api/fms/finance/feeNote/exportPromoteXmtTuitionFee", p, c),
  },
  feeNote_exportPromoteNetTuitionFee: {
    /*
     * 网络推广学费收费单导出
     */
    get: (p, c) =>
      $.get("/api/fms/finance/feeNote/exportPromoteNetTuitionFee", p, c),
  },
  feeNote_exportFollowTuitionFee: {
    /*
     * 催费导出
     */
    get: (p, c) =>
      $.get("/api/fms/finance/feeNote/exportFollowTuitionFee", p, c),
  },
  feeNote_exportFollowTuitionFeeForService: {
    /*
     * 服务部催费列表导出
     */
    get: (p, c) =>
      $.get("/api/fms/finance/feeNote/exportFollowTuitionFeeForService", p, c),
  },
  feeNote_exportFollowTuitionFeeForContinue: {
    /*
     * 服务部催费列表导出
     */
    get: (p, c) =>
      $.get("/api/fms/finance/feeNote/exportFollowTuitionFeeForContinue", p, c),
  },
  feeNote_exportAiMarketingTuitionFee: {
    /*
     * AI营销收费单导出
     */
    get: (p, c) =>
      $.get("/api/fms/finance/feeNote/exportAiMarketingTuitionFee", p, c),
  },
  feeNote_downloadRestoreModule: {
    /*
     * 下载修复模版
     */
    get: (p, c) =>
      $.get("/api/fms/finance/feeNote/downloadRestoreModule", p, c),
  },
  feeNote_detailsForStudent: {
    /*
     * 收费单详情
     * id 收费单id (integer query required)
     */
    get: (p, c) => $.get("/api/fms/finance/feeNote/detailsForStudent", p, c),
  },

  /**
   * 收费单优惠
   */
  feeDiscount_testFinish: {
    /*
     * 测试审核完成
     * id id (integer query required)
     */
    put: (p, c) => $.put("/api/fms/finance/feeDiscount/testFinish", p, c),
  },
  feeDiscount_sync: {
    /*
     * 同步
     * id id (integer query required)
     */
    put: (p, c) => $.put("/api/fms/finance/feeDiscount/sync", p, c),
  },
  feeDiscount_apply: {
    /*
     * 申请
     * feeId 收费单 (integer query required)
     * configId 配置id (integer query )
     * type 类型 (string query )
     * amount 优惠金额 (number query )
     * firstFinishAmount 首次缴费优惠金额 (number query )
     * remark 备注 (string query )
     * dingDepartmentId 钉钉部门id (integer query )
     * enterpriseId 企业id (integer query )
     * workPhoto 工作证明 (string query )
     */
    post: (p, c) => $.post("/api/fms/finance/feeDiscount/apply", p, c),
  },
  feeDiscount_list: {
    /*
     * 优惠列表
     * feeId 收费单id (integer query required)
     */
    get: (p, c) => $.get("/api/fms/finance/feeDiscount/list", p, c),
  },

  /**
   * 钉钉付款单
   */
  dingPayment: {
    /*
     * 编辑，财务审核状态审核中或者拒绝可以编辑，钉钉状态审核通过了无法编辑金额和备注
     * id id (integer query required)
     * amount 金额 (number query )
     * accountType 账号类型： (string query )
     * accountNick 账号名字称或昵称 (string query )
     * account 账号 (string query )
     * remark 备注 (string query )
     */
    put: (p, c) => $.put("/api/fms/finance/dingPayment", p, c),
  },
  dingPayment_sync: {
    /*
     * 同步
     * id id (integer query required)
     */
    put: (p, c) => $.put("/api/fms/finance/dingPayment/sync", p, c),
  },
  dingPayment_remark: {
    /*
     * 打款备注
     * id id (integer query required)
     * remark 备注 (string query )
     */
    put: (p, c) => $.put("/api/fms/finance/dingPayment/remark", p, c),
  },
  dingPayment_pay: {
    /*
     * 打款
     * id id (integer query required)
     * payAccount 打款账号 (string query required)
     * remark 备注 (string query )
     * needSceneInfo 是否需要转账场景信息（新商户必传；true=带，false=不带，不传默认带） (boolean query )
     */
    put: (p, c) => $.put("/api/fms/finance/dingPayment/pay", p, c),
  },
  dingPayment_audit: {
    /*
     * 审核
     * id id (integer query required)
     * auditStatus 审核状态：通过，拒绝 (string query required)
     * remark 备注 (string query )
     * version 版本 (integer query )
     */
    put: (p, c) => $.put("/api/fms/finance/dingPayment/audit", p, c),
  },
  dingPayment_apply: {
    /*
     * 申请
     * contentId 内容id（目前传学籍id） (integer query required)
     * type 类型:特殊优惠返款,学费业务退费,特殊补偿退款 (string query required)
     * amount 金额 (number query required)
     * accountType 账号类型： (string query required)
     * accountNick 账号名字称或昵称 (string query required)
     * account 账号 (string query required)
     * remark 备注 (string query required)
     * dingDepartmentId 钉钉部门id (integer query required)
     */
    post: (p, c) => $.post("/api/fms/finance/dingPayment/apply", p, c),
  },
  dingPayment_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/fms/finance/dingPayment/list", p, c),
  },
  dingPayment_listSimple: {
    /*
     * 列表
     * contentId 内容id（目前传学籍id） (integer query required)
     */
    get: (p, c) => $.get("/api/fms/finance/dingPayment/listSimple", p, c),
  },
  dingPayment_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/fms/finance/dingPayment/export", p, c),
  },
  dingPayment_details: {
    /*
     * 详情
     * id 订单id (integer query required)
     */
    get: (p, c) => $.get("/api/fms/finance/dingPayment/details", p, c),
  },

  /**
   * 财务账号
   */
  account_updateName: {
    /*
     * 编辑户名
     * id id (integer query required)
     * name 户名 (string query required)
     */
    put: (p, c) => $.put("/api/fms/finance/account/updateName", p, c),
  },
  account_sync: {
    /*
     * 同步余额
     * id id (integer query required)
     * balance 余额 (number query required)
     */
    put: (p, c) => $.put("/api/fms/finance/account/sync", p, c),
  },
  account_setUnusableAmount: {
    /*
     * 设置不可用资金
     * amount 金额 (number query required)
     */
    put: (p, c) => $.put("/api/fms/finance/account/setUnusableAmount", p, c),
  },
  account_setOutLoan: {
    /*
     * 设置外部借款
     * amount 金额 (number query required)
     */
    put: (p, c) => $.put("/api/fms/finance/account/setOutLoan", p, c),
  },
  account_setFundsAdminId: {
    /*
     * 设置有权限查看资金页面的管理员id
     * adminIds 有权限查看的管理员id (array query required)
     */
    put: (p, c) => $.put("/api/fms/finance/account/setFundsAdminId", p, c),
  },
  account: {
    /*
     * 添加
     * account  ( query required)
     */
    post: (p, c) => $.post("/api/fms/finance/account", p, c),
  },
  account_remind: {
    /*
     * 提醒
     * adminIds id (array query required)
     * title 通知标题 (string query required)
     * content 通知内容 (string query required)
     */
    post: (p, c) => $.post("/api/fms/finance/account/remind", p, c),
  },
  account_list: {
    /*
     * 财务账号单列表
     */
    get: (p, c) => $.get("/api/fms/finance/account/list", p, c),
  },
  account_listName: {
    /*
     * 户名列表
     */
    get: (p, c) => $.get("/api/fms/finance/account/listName", p, c),
  },
  account_listFundsAdminId: {
    /*
     * 有权限查看资金页面的管理员id
     */
    get: (p, c) => $.get("/api/fms/finance/account/listFundsAdminId", p, c),
  },
  account_incomeExpenseInfo: {
    /*
     * 资金预测-收入（支出）
     * start 开始时间 (string query required)
     * end 结束时间 (string query required)
     * type 类型：收入|支出 (string query required)
     */
    get: (p, c) => $.get("/api/fms/finance/account/incomeExpenseInfo", p, c),
  },
  account_getUnusableAmount: {
    /*
     * 获取不可用资金
     */
    get: (p, c) => $.get("/api/fms/finance/account/getUnusableAmount", p, c),
  },
  account_getOutLoan: {
    /*
     * 获取外部借款
     */
    get: (p, c) => $.get("/api/fms/finance/account/getOutLoan", p, c),
  },
  account_getCurrentBalance: {
    /*
     * 根据账号获取当前余额
     * id id (integer query required)
     */
    get: (p, c) => $.get("/api/fms/finance/account/getCurrentBalance", p, c),
  },
  account_export: {
    /*
     * 批量导出
     */
    get: (p, c) => $.get("/api/fms/finance/account/export", p, c),
  },
  account_exportBalance: {
    /*
     * 实时余额导出
     * date 日期 (string query required)
     */
    get: (p, c) => $.get("/api/fms/finance/account/exportBalance", p, c),
  },
  account_accountFinanceInfo: {
    /*
     * 资金预测-账户资金情况
     */
    get: (p, c) => $.get("/api/fms/finance/account/accountFinanceInfo", p, c),
  },

  /**
   * 学生缴费单标准
   */
  studentFeesStandard: {
    /*
     * 添加
     * standard  ( query required)
     */
    post: (p, c) => $.post("/api/fms/finance/studentFeesStandard", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/fms/finance/studentFeesStandard", p, c),
  },
  studentFeesStandard_upload: {
    /*
     * 导入
     * excelFile  (string body required)
     */
    post: (p, c) => $.post("/api/fms/finance/studentFeesStandard/upload", p, c),
  },
  studentFeesStandard_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/fms/finance/studentFeesStandard/list", p, c),
  },
  studentFeesStandard_listStandardByTeacher: {
    /*
     * 获取学生缴费单标准
     * schoolRollId 合同id (integer query required)
     * type 缴费类型 (string query required)
     */
    get: (p, c) =>
      $.get("/api/fms/finance/studentFeesStandard/listStandardByTeacher", p, c),
  },
  studentFeesStandard_listByStudentInfo: {
    /*
     * 获取学生缴费单C端信息
     * batch 批次 (string query required)
     * siteId 学校id (integer query required)
     * type 缴费类型 (string query required)
     * idCardNo 身份证 (string query required)
     */
    get: (p, c) =>
      $.get("/api/fms/finance/studentFeesStandard/listByStudentInfo", p, c),
  },
  studentFeesStandard_export: {
    /*
     * 批量导出
     */
    get: (p, c) => $.get("/api/fms/finance/studentFeesStandard/export", p, c),
  },
  studentFeesStandard_createStudentFees: {
    /*
     * 生成学生缴费单
     * batch 批次 (string query required)
     * siteId 学校id (integer query required)
     * type 缴费类型 (string query required)
     * idCardNo 身份证 (string query required)
     * standardIds 标准id (array query required)
     */
    get: (p, c) =>
      $.get("/api/fms/finance/studentFeesStandard/createStudentFees", p, c),
  },
  studentFeesStandard_createStudentFeesByTeacher: {
    /*
     * 生成学生缴费单
     * schoolRollId 合同id (integer query required)
     * type 缴费类型 (string query required)
     * standardIds 标准id (array query required)
     */
    get: (p, c) =>
      $.get(
        "/api/fms/finance/studentFeesStandard/createStudentFeesByTeacher",
        p,
        c
      ),
  },

  /**
   * 学生缴费单优惠
   */
  studentFeesDiscount: {
    /*
     * 添加
     * discount  ( query required)
     */
    post: (p, c) => $.post("/api/fms/finance/studentFeesDiscount", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/fms/finance/studentFeesDiscount", p, c),
  },
  studentFeesDiscount_upload: {
    /*
     * 导入
     * file  (string body required)
     */
    post: (p, c) => $.post("/api/fms/finance/studentFeesDiscount/upload", p, c),
  },
  studentFeesDiscount_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/fms/finance/studentFeesDiscount/list", p, c),
  },
  studentFeesDiscount_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/fms/finance/studentFeesDiscount/export", p, c),
  },

  /**
   * 返款发票
   */
  paymentReceipt: {
    /*
     * 添加
     * receipt  ( query required)
     */
    post: (p, c) => $.post("/api/fms/finance/paymentReceipt", p, c),
  },
  paymentReceipt_sync: {
    /*
     * 同步
     */
    post: (p, c) => $.post("/api/fms/finance/paymentReceipt/sync", p, c),
  },
  paymentReceipt_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/fms/finance/paymentReceipt/list", p, c),
  },
  paymentReceipt_listSite: {
    /*
     * 学校列表
     */
    get: (p, c) => $.get("/api/fms/finance/paymentReceipt/listSite", p, c),
  },

  /**
   * 收支明细类别
   */
  incomeExpenseType: {
    /*
     * 添加
     * type  ( query required)
     */
    post: (p, c) => $.post("/api/fms/finance/incomeExpenseType", p, c),
  },
  incomeExpenseType_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/fms/finance/incomeExpenseType/list", p, c),
  },
  incomeExpenseType_listType: {
    /*
     * 类型列表
     */
    get: (p, c) => $.get("/api/fms/finance/incomeExpenseType/listType", p, c),
  },
  incomeExpenseType_listSubType: {
    /*
     * 子类型列表
     * type 类别 (string query required)
     */
    get: (p, c) =>
      $.get("/api/fms/finance/incomeExpenseType/listSubType", p, c),
  },

  /**
   * 优惠返款配置
   */
  discountPaymentConfig: {
    /*
     * 添加
     * config  ( query required)
     */
    post: (p, c) => $.post("/api/fms/finance/discountPaymentConfig", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/fms/finance/discountPaymentConfig", p, c),
  },
  discountPaymentConfig_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/fms/finance/discountPaymentConfig/list", p, c),
  },

  /**
   * 优惠配置
   */
  discountConfig: {
    /*
     * 添加
     * config  ( query required)
     */
    post: (p, c) => $.post("/api/fms/finance/discountConfig", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/fms/finance/discountConfig", p, c),
  },
  discountConfig_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/fms/finance/discountConfig/list", p, c),
  },
  discountConfig_listCurrent: {
    /*
     * 当前列表
     * schoolRollId 合同id (integer query required)
     */
    get: (p, c) => $.get("/api/fms/finance/discountConfig/listCurrent", p, c),
  },
  discountConfig_getReferral: {
    /*
     * 获取老带新优惠配置
     * siteType 学校类型 (string query required)
     */
    get: (p, c) => $.get("/api/fms/finance/discountConfig/getReferral", p, c),
  },

  /**
   * 待查订单
   */
  checkOrder_upload: {
    /*
     * 导入
     * excelFile  (string body required)
     */
    post: (p, c) => $.post("/api/fms/finance/checkOrder/upload", p, c),
  },
  checkOrder_list: {
    /*
     * 待查订单列表
     */
    get: (p, c) => $.get("/api/fms/finance/checkOrder/list", p, c),
  },
  checkOrder_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/fms/finance/checkOrder/export", p, c),
  },
  checkOrder_downloadModule: {
    /*
     * 下载模版
     */
    get: (p, c) => $.get("/api/fms/finance/checkOrder/downloadModule", p, c),
  },
  checkOrder_articulationPayTime: {
    /*
     * 勾稽收款间
     * start 开始时间 (string query required)
     * end 结束时间 (string query required)
     */
    get: (p, c) =>
      $.get("/api/fms/finance/checkOrder/articulationPayTime", p, c),
  },
  checkOrder_articulationConfirmTime: {
    /*
     * 勾稽出纳确认时间
     * start 开始时间 (string query required)
     * end 结束时间 (string query required)
     */
    get: (p, c) =>
      $.get("/api/fms/finance/checkOrder/articulationConfirmTime", p, c),
  },
  checkOrder: {
    /*
     * 删除
     * id 待查订单id (integer query required)
     */
    delete: (p, c) => $.delete("/api/fms/finance/checkOrder", p, c),
  },

  /**
   * 财务余额记录
   */
  accountBalanceRecord_list: {
    /*
     * 财务账号余额记录列表
     */
    get: (p, c) => $.get("/api/fms/finance/accountBalanceRecord/list", p, c),
  },
};
